module.exports = __webpack_public_path__ + "img/women-office-with-kid-banner-3.f3e0e3ab.png";